// src/services/contactApi.js
const API_URL = 'https://common-contact-api.zirke.eu';
// const API_URL = 'http://localhost:3333';

export async function sendContactRequest(payload) {
    const body = {
        name: payload.name,
        email: payload.email,
        subject: payload.subject,
        message: payload.message,
        projectId: 'js-werner',
        timestamp: payload.formStartedAt
    };

    const response = await fetch(`${API_URL}/contact`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || `Fehler ${response.status}`);
    }

    return response.json();
}